import React from "react";
import { Link } from "react-router-dom";
import "./ServicePages.css";
import Seo from "../components/Seo";

const posts = [
  {
    title: "How Often Should Landlords Repaint Rentals in Kingwood?",
    slug: "/blog/how-often-should-landlords-repaint-rentals-kingwood",
    excerpt:
      "Learn how often to repaint rentals in Kingwood, what affects the timeline, and how standard colors and Fast Flash keep turnovers on schedule.",
    category: "Landlords",
    readingTime: "4 min read",
  },
  {
    title: "How J3 Innovations Builds Your Painting Estimate in Kingwood",
    slug: "/blog/how-we-build-your-painting-estimate-kingwood",
    excerpt:
      "See exactly how we price painting projects in Kingwood—scope, prep, products, and schedule—so you know what goes into your estimate.",
    category: "Pricing",
    readingTime: "3 min read",
  },
];

const BlogIndex = () => {
  return (
    <div className="page-shell" data-theme="blog">
      <Seo
        title="Painting Blog for Kingwood & Houston | J3 Innovations"
        description="Painting tips and guides for Kingwood and Houston: repaint timelines, estimates, rental refreshes, and more from J3 Innovations."
        canonicalPath="/blog"
        image="/logo192.png"
      />
      <div className="page-wrap">
        <div className="page-hero">
          <p className="page-eyebrow">J3 Innovations Blog</p>
          <h1>Painting Tips &amp; Guides for Kingwood and Houston</h1>
          <p className="lead">
            Practical posts for landlords, homeowners, Airbnb hosts, and property managers. Find repaint timelines, prep tips, and links to our services.
          </p>
        </div>

        <div className="section-block">
          <h2>Latest Posts</h2>
          <div className="blog-grid">
            {posts.map((post) => (
              <div className="bullet-card" key={post.slug}>
                <h3>{post.title}</h3>
                <p>{post.excerpt}</p>
                <div className="blog-meta">
                  <span className="blog-chip">{post.category}</span>
                  <span className="blog-time">{post.readingTime}</span>
                </div>
                <Link to={post.slug} className="cta-inline">
                  Read more →
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogIndex;
